import { Features } from '../../../constants/features';
import { FeatureFlagDeclarations } from '../../../feature-flags/feature-flag-declarations';
import { useFeatureFlag } from '../../../feature-flags/hooks/use-feature-flag';
import { useIsSellerFeatureEnabled } from '../../../hooks/use-is-seller-feature-enabled';

export const useShouldShowShippyButton = (): boolean => {
  const enabledWithFeatureFramework = useIsSellerFeatureEnabled(Features.AiShippyAssistant);
  const enabledWithFeatureFlag = useFeatureFlag(FeatureFlagDeclarations.enableAiShippyAssistant);

  return enabledWithFeatureFramework && enabledWithFeatureFlag;
};
